import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Icon, type IconNameString } from '@videoblocks/design-system';

const baseCls =
    'inline-flex items-center gap-1 text-base rounded-sm px-2 py-1 border-0 text-white bg-black/15 cursor-pointer';

interface AISearchOptionProps {
    label: string;
    iconName: IconNameString;
    href?: string;
    onClick?: () => void;
}

export default function AISearchOption({ label, iconName, href, onClick }: AISearchOptionProps): JSX.Element {
    if (href) {
        return (
            <a href={href} className={twMerge(baseCls, 'no-underline')} onClick={onClick}>
                <Icon name={iconName} width={16} height={16} className="[&_path]:fill-white [&_path]:stroke-white" />
                {label}
            </a>
        );
    }

    return (
        <button type="button" onClick={onClick} className={baseCls}>
            <Icon name={iconName} width={16} height={16} className="[&_path]:fill-white" />
            {label}
        </button>
    );
}
